import { render, staticRenderFns } from "./PaymentLinkDlg.vue?vue&type=template&id=70c1e5f0&scoped=true&"
import script from "./PaymentLinkDlg.vue?vue&type=script&lang=js&"
export * from "./PaymentLinkDlg.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1e5f0",
  null
  
)

export default component.exports